module.exports = __webpack_public_path__ + "b983d5076490bbc6f0f5fb268b0c73bf.pdf";